import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SocialButton from './SocialButton.jsx';
import Variables from '../../../../../variables/Variables.js';
import { russiaMKId } from '../../../utils/StoreConfigManager.js';

const storeId = Variables.storeId;

const pinterestIcon = 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/pinterest.svg';
const russiaPinterestIcon = 'https://cdn.obsess-vr.com/mary-kay/odnoklassniki.png';

export default class PinterestButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null
        };

        // getPinterestAsync()
        // .then(url => this.setState({ imageUrl: url }))
        // .catch(error => console.error(error));
    }

    render() {
        const { color, profileUrl } = this.props;
        // const imageSrc = this.state.imageSrc;
        return (
            <SocialButton
                imageSrc={(storeId === russiaMKId) ? russiaPinterestIcon : pinterestIcon}
                style={this.props.style}
                redirectUrl={profileUrl}
                color={color}
            // onClickAnalytics={FacebookButtonAnalytics}
            />
        );
    }
}

PinterestButton.propTypes = {
    style: Proptypes.object
};
